import { baseApiUrl } from "../../../../../../env";
import axiosInstance from '../../../../../../Axios/axios'



// const useGetProformaInvoiceReport = (requestBody, apiProps) => {
//   const dispatch = useDispatch();
//   let totalRecord;
//   const body = { ...requestBody, ...apiProps.reportDTO };
//   return useQuery(
//     ["GetProformaInvoiceReport", requestBody, apiProps],
//     () =>
//       customApi({
//         apiType: "post",
//         url: "/api/v1/ReportList/GetProformaInvoiceReport",
//         reactQuery: "query",
//         requestBody: body,
//       }),
//     {
//       enabled: !!body,
//       refetchOnWindowFocus: false,
//       onSuccess: () => {
//         dispatch(getOrderTotalR(totalRecord));
//       },
//       onError: () => {},
//       select: (data) => {
//         totalRecord = data?.data.data.totalRecords; //for pagnation
//         const footer = data?.data.data.fotter;
//         let res = data?.data.data.items;
//         dispatch(setReportListFooterR(footer));
//         return res;
//       },
//     }
//   );
// };

const GetProformaInvoiceReport = async ({ queryKey }) => {
    let body = queryKey[1];
    let url = 'ReportList/GetProformaInvoiceReport';
    return await axiosInstance.post(url, body)
}


// const useGetProformaInvoiceSearchDTO = () => {
//   return useQuery(
//     ["GetProformaInvoiceSearchDTO"],
//     () =>
//       customApi({
//         apiType: "get",
//         url: "/api/v1/ReportList/GetProformaInvoiceSearchDTO",
//         reactQuery: "query",
//       }),
//     {
//       //enabled: true,
//       refetchOnWindowFocus: false,
//       staleTime: 5 * 60 * 1000,
//       cacheTime: 30 * 60 * 1000,
//       onError: () => {},
//       select: (data) => {
//         let res = data?.data.data;
//         return res;
//       },
//     }
//   );
// };




const GetProformaInvoiceSearchDTO = async () => {
    let url = 'ReportList/GetProformaInvoiceSearchDTO'
    return await axiosInstance.get(url)
}





// http://192.168.3.17:91/api/v1/ReportList/GetProformaInvoiceReportTotal
const GetProformaInvoiceReportTotal=async({ queryKey })=>{
    let body = queryKey[1];
    return await  axiosInstance.post('ReportList/GetProformaInvoiceReportTotal',body)
}


export {
    GetProformaInvoiceReport,
    GetProformaInvoiceSearchDTO,
    GetProformaInvoiceReportTotal
}